module.exports = __webpack_public_path__ + "5c22305f2fe8bfc72dd099a64792bf6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page.png
// module id = 1052
// module chunks = 0